import React from 'react';
import './PaymentPage.css';

const PaymentPage = ({ userData, onUpgrade }) => {
  const usage = typeof userData?.dailyUsage === 'number' ? userData.dailyUsage : 0;
  const usagePercent = Math.min((usage / 120) * 100, 100);

  return (
    <div className="payment-page-wrapper">
      <header className="payment-header">
        <h1>Usage & Billing</h1>
        <p>Monitor your AI processing consumption and plan details.</p>
      </header>

      <div className="payment-content-grid">
        {/* Resource Usage Card */}
        <section className="payment-card highlight-card">
          <div className="payment-card-header">
            <i className="fas fa-chart-line"></i>
            <h3>Resource Usage</h3>
          </div>
          <div className="payment-card-body">
            <div className="usage-display">
              <div className="usage-info">
                <span className="usage-number">{usage}</span>
                <span className="usage-total">/ 120 minutes used today</span>
              </div>
              <div className="usage-progress-track">
                <div 
                  className="usage-progress-fill" 
                  style={{ width: `${usagePercent}%` }}
                ></div>
              </div>
              <p className="usage-hint">Usage resets daily at 00:00 UTC</p>
            </div>
          </div>
        </section>

        {/* Subscription Card */}
        <section className="payment-card">
          <div className="payment-card-header">
            <i className="fas fa-crown"></i>
            <h3>Current Subscription</h3>
          </div>
          <div className="payment-card-body">
            <div className="subscription-info">
              <div className="tier-badge-large">{userData?.plan || 'FREE'} ACCESS</div>
              <ul className="plan-features">
                <li><i className="fas fa-check"></i> Standard AI Models</li>
                <li><i className="fas fa-check"></i> 120 min daily limit</li>
                <li><i className="fas fa-clock"></i> Normal response speed</li>
              </ul>
            </div>
            <button className="payment-upgrade-btn" onClick={onUpgrade}>
              Upgrade to Pro
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PaymentPage;